import React from "react";
import { Form, Input, Button } from "antd";
import { Col, Container, Row } from "react-bootstrap";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";
import Notification from "../../services/Notification";

const courier = () => {
  const onFinish = async (values) => {
    let data = await axios
      .patch("/update-courier", {
        ordersId: Number(values.ordersId),
        trackingId: values.trackingId,
      })
      .catch((error) => {
        Helper.ErrorHanlder(error);
      });
    if (data && data.data) {
      Notification.success("Tracking ID updated Successfully");
    }
  };

  return (
    <Container fluid>
      <div className="settings-pg">
        <Row>
          <Col md={12}>
            <Form layout={"vertical"} onFinish={onFinish}>
              <Form.Item
                label="Order ID"
                name="ordersId"
                rules={[
                  {
                    required: true,
                    message: "Order ID is required",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Tracking ID"
                name="trackingId"
                rules={[
                  {
                    required: true,
                    message: "Tracking ID is required",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item style={{ textAlign: "left" }}>
                <Button type="primary" htmlType="submit">
                  Update
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default courier;
